import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";

class StockMovementDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            movement: null,
            isLoad: true
        }
    }

    componentDidMount() {
        this.fetchMovementDetail();
    }

    fetchMovementDetail = async () => {
        const {id} = this.props.match.params;
        try {
            const response = await apiCall(`business/stock/movement/info/${id}`,'get');
            if(response.status === 'success' && response.data) {
                this.setState({movement: response.data, isLoad: false});
            } else {
                this.setState({isLoad: false});
            }
        } catch (e) {
            console.error(e);
            this.setState({isLoad: false});
        }
    }

    getMovementTypeLabel = (type) => {
        const types = {
            'purchase': 'Satın Alma',
            'sale': 'Satış',
            'transfer_in': 'Transfer Giriş',
            'transfer_out': 'Transfer Çıkış',
            'adjustment': 'Düzeltme',
            'return': 'İade'
        };
        return types[type] || type;
    }

    getMovementTypeBadge = (type) => {
        const badges = {
            'purchase': 'badge-success',
            'sale': 'badge-danger',
            'transfer_in': 'badge-info',
            'transfer_out': 'badge-warning',
            'adjustment': 'badge-secondary',
            'return': 'badge-primary'
        };
        return badges[type] || 'badge-secondary';
    }

    render() {
        const {movement, isLoad} = this.state;

        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div className="page-loader-wrapper" style={{display: isLoad ? 'block' : 'none'}}>
                    <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <div className="m-t-30">
                            <img src={require('../../../assets/images/logo-white.png')} width="150" alt="Servicezone"/>
                        </div>
                        <p>Yükleniyor</p>
                        <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
                    </div>
                </div>
                {!isLoad && !movement && (
                    <div className="text-center p-5">Hareket bulunamadı.</div>
                )}
                {!isLoad && movement && (
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Stok Hareketi Detay"
                            Breadcrumb={[
                                { name: "Stok Yönetimi", navigate: "" },
                                { name: "Stok Hareketleri", navigate: "stock/movements" },
                                { name: "Hareket Detay", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-8 col-md-12">
                                <div className="card">
                                    <div className="header">
                                        <h2>Hareket Bilgileri</h2>
                                    </div>
                                    <div className="body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <p><strong>Hareket ID:</strong> #{movement.id}</p>
                                                <p><strong>Depo:</strong> {movement.warehouse ? movement.warehouse.name : '-'}</p>
                                                <p><strong>Stok Kalemi:</strong> {movement.stock_item ? movement.stock_item.name : '-'}</p>
                                                <p><strong>SKU:</strong> {movement.stock_item && movement.stock_item.sku ? movement.stock_item.sku : '-'}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p>
                                                    <strong>Hareket Tipi:</strong>{' '}
                                                    <span className={`badge ${this.getMovementTypeBadge(movement.movement_type)}`}>
                                                        {this.getMovementTypeLabel(movement.movement_type)}
                                                    </span>
                                                </p>
                                                <p><strong>Miktar:</strong> <span className="text-primary">{Math.round(movement.quantity || 0)}</span></p>
                                                <p><strong>Hareket Tarihi:</strong> {new Date(movement.movement_date).toLocaleString('tr-TR')}</p>
                                                <p><strong>İşlemi Yapan:</strong> {movement.user ? movement.user.name : '-'}</p>
                                            </div>
                                        </div>
                                        {movement.notes && (
                                            <div className="row mt-3">
                                                <div className="col-12">
                                                    <p><strong>Notlar:</strong></p>
                                                    <p className="text-muted">{movement.notes}</p>
                                                </div>
                                            </div>
                                        )}
                                        {movement.reference_type && (
                                            <div className="row mt-3">
                                                <div className="col-12">
                                                    <p><strong>Referans:</strong> {movement.reference_type} #{movement.reference_id}</p>
                                                </div>
                                            </div>
                                        )}
                                        <div className="row mt-4">
                                            <div className="col-12">
                                                <button 
                                                    className="btn btn-secondary"
                                                    onClick={() => this.props.history.push('/stock/movements')}
                                                >
                                                    <i className="icon-arrow-left"></i> Geri Dön
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(StockMovementDetail));

